export const USER_ERROR_CODES = {
    CUSTOMER_GET_FAILURE: "CustomerGetFailure",
} as const;
